export default __webpack_public_path__ + "media/images/images/icons/opera-44a23b36f2dd01093f0ee2c35c3b26d6.png";